var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"height":"100%"}},[_c('Sidebar',{attrs:{"disabled":_vm.sidebarDisabled}}),_vm._v(" "),_c('ResultPage',{attrs:{"sharedTest":_vm.sharedTest},on:{"beforeRender":_vm.beforeRender,"afterRender":_vm.afterRender}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b7e1d3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ShowMore.vue
// module id = null
// module chunks = 